import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import './index.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import JsBridgeNew from "@/utils/jsbridgeNew";
import {objectToQueryParams} from "@/utils/publicFun";
import qs from "query-string";
import { copyText} from "@/utils/publicFun"
import NumberScroll from '@/components/NumberScroll';

/**
 * @description 茅台二期
 * @return {/culturalExchange_maotaisecond/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]
const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const [hasPermission, setHasPermission] = useState(false)
  // const [shiwuThing, setShiwuThing] = useState({})
  const { nftNo } = qs.parse(window.location.search);
  const [pageType, setPageType] = useState(0)//页面类型 1优先购 2特权购 3公开购

  

  useEffect(() => {
    (()=>{
      getData(true);
      onDidFocus();
      // getData2()
    })()

  }, []);
//   const getData2 = async () => {
//     try {
//         showLoading()
//         const res = await Service.getGoodsDetail({collectionId: Service.collectionId})
//         hideLoading();
//         if (res.code !== '000000') throw res.msg;
//         if (res.data && res.data.info) {
//             setDetailData(res.data.info)
//         }
//     } catch (error) {
//         Toast.show(error);
//     }
  
// }
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    // const res2 = await Service.getGoodsData({},nftNo);
    try {
      if (loading) showLoading();
      if (loading) {
        const userInfoRes = await Service.getUserCertificateStatus();
        const accessRes = await Service.purchasePermissions();
        setUserInfo(userInfoRes);
        // setHasPermission(accessRes.data?.isPermission);
        // console.log(accessRes.data, accessRes.data.isPermission);
        // const res2 = await Service.getGoodsData({},nftNo);
        // if(res2?.data?.length > 0){
        //   const shiwu = res2.data.find(item => item?.goodsType === 3)
        //   console.log('shiwu===>', shiwu)
        //   setShiwuThing(shiwu)
        // }
      }
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data);
      setHasPermission(res.data?.isPermission)
      setPageType(parseInt(res.data?.flag) || 0)
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);

  const buyHandle = () => {
    if(!hasPermission||(data?.allowNum ===0 && (pageType ===1 || pageType ===2))){
      return;
    }
    // const bynum = pageType === 1 ? (data?.ordNum || 0) : pageType === 2?(data?.rareNum || 0):0;
    // if(bynum === 0){
    //   Toast.show("超过购买数量");
    //   return;
    // }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    const uri = `/ape/saleDetail?collectionId=${Service.collectionId}&code=${Service.activityCode}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      });
    } else {
      navigate(uri);
    }
    
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }
  // 将数字转换为固定8位字符串，不足位数前面补0
  const formatPointPool = (value, length = 8) => {
    if (value === null || value === undefined || value === '') {
      return '0'.repeat(length);
    }
    const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
    if (isNaN(numValue)) {
      return '0'.repeat(length);
    }
    return String(numValue).padStart(length, '0');
  };

   //立即领取 ，跳转G-member订单页面
   const handleToOrder = async (type) => {
    //type 1 优先购 2 全套漫画
    // Toast.show(data?.canNum);
    if(!data?.badgeNum) {
      Toast.show('暂无权益可领');
      return
    }
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const param = objectToQueryParams({
        idf: 'exchangeCultural_gold',
        activityCode: Service.activityCode,
        req: data?.defaultGoods?.id,
        name: data?.defaultGoods?.goodsName,
        imgUrl: data?.defaultGoods?.imgUrl,
        productId:data?.defaultGoods?.goodsId,
        isChangeName:0,
        clientId: userInfo?.clientId,
        skUId: data?.defaultGoods?.goodsId,
        prizeImgUrl: data?.defaultGoods?.imgUrl,
        prizeName: data?.defaultGoods?.goodsName,
        nftNo: nftNo,
        remark: 1,
        needShowCount:data?.badgeNum,
      });
      window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
      onDidFocus();
  }
   //立即领取 ，跳转G-member订单页面
   const handleToOrder2 = async () => {
    const param = objectToQueryParams({
      id: data?.badgeRecord?.id,
      phone: data?.badgeRecord?.phone,
      prizeImgUrl: data?.badgeRecord?.productImgUrl,
      prizeName: data?.badgeRecord?.productName,
      prizeType: data?.badgeRecord?.productType,
      skuId: data?.defaultGoods?.goodsId,
      createTime: data?.badgeRecord?.createTime,
      consigneeName: data?.badgeRecord?.consigneeName,
      consigneeNumber: data?.badgeRecord?.consigneeNumber,
      province: data?.badgeRecord?.province,
      city: data?.badgeRecord?.city,
      area: data?.badgeRecord?.area,
      street: data?.badgeRecord?.street,
      address: data?.badgeRecord?.address,
      deliverStatus:data?.badgeRecord?.deliverStatus,
      deliverGoods:data?.badgeRecord?.deliverGoods||0,
      logCo:data?.badgeRecord?.logCo||"",
      trackNo:data?.badgeRecord?.trackNo||"",
      shipDate:data?.badgeRecord?.shipDate||"",
      orderId:data?.badgeRecord?.orderId||"",
      needShowCount:data?.badgeRecord?.desc,
    });
    window.JsBridge.push('CustomWeb', { uri: `${process.env.REACT_APP_GKT_LINK}/front/activities/lottery/orderDetail?${param}`});
      onDidFocus();
  }
  return (
    <div className={Styles.culturalExchangeHome} ref={pageDom}>
       <div className={Styles.topCard}>

      </div>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && userInfo?.ID) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <div className={Styles.hintBtnBox}>
          <div className={Styles.hintBtn1}>
            <img src={require(pageType === 1 ? '@/assets/img/culturalExchange_euro/hint21.png' : pageType===2?'@/assets/img/culturalExchange_euro/hint22.png':pageType===3?'@/assets/img/culturalExchange_euro/hint23.png':'@/assets/img/culturalExchange_euro/hint24.png')} alt="hint1" />
          </div>
      </div>
      <div className={Styles.hintBtnBox2}>【第二期】</div>
      <div className='nums_box'>
      </div>
      <div className='nums_bg'>
          {/* <NumberScroll textStyle={{ width: 35, height: 80 }} startValue={'00000000'} endValue={dataSource.maxPool ?? '00000000'} /> */}
          <NumberScroll textStyle={{ width: 35, height: 80 }} startValue={'00000000'} endValue={formatPointPool(data?.pointPool)} />
      </div>
      <div className={Styles.imagebox}>
        <img src={require('@/assets/img/culturalExchange_euro/obj.png')} alt="image" />
      </div>
      <div className={Styles.buyBtn} style={{ filter: hasPermission &&(data?.allowNum >0 || pageType===3) ? '' : 'grayscale(1)'}} onClick={buyHandle} disabled={hasPermission&&(data?.allowNum >0 || pageType===3)?false:true}>
        {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
      </div>
      {/* <button className={Styles.myCollectionsBtn} onClick={toMyGuards}>我的藏品{">"}</button> */}
      {data?.allowNum && <div className={Styles.textCount}>最多可购买{data?.allowNum || 0}个</div>}
      {/* <div className={Styles.textCount}>最多可购买{data?.allowNum || 0}个</div> */}
      {/* <div className={Styles.textCount}>剩余可购买数量：{pageType === 1 ? (data?.ordNum || 0) : pageType === 2?(data?.rareNum || 0):0}</div> */}
      {!data?.hasBadgeFlag&&<div className={Styles.getBtn} onClick={handleToOrder}></div>}
      {data?.hasBadgeFlag&&<div className={Styles.getBtn2} onClick={handleToOrder2}>
        查看详情
        </div>}
      <div className={Styles.footerBox}>
            <div className={Styles.footer}></div>
          </div>

    </div>
  )
}
export default Home
